import { render, staticRenderFns } from "./settlementAdd.vue?vue&type=template&id=476818f0&scoped=true"
import script from "./settlementAdd.vue?vue&type=script&lang=js"
export * from "./settlementAdd.vue?vue&type=script&lang=js"
import style0 from "./settlementAdd.vue?vue&type=style&index=0&id=476818f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476818f0",
  null
  
)

export default component.exports